// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__rPZ6C","blockWrapper":"Layout_blockWrapper__nNqLX","block":"Layout_block__iKgNR"};